export const chartColors = (isDark = false) => {
  return ['#3b0c33', '#5a1250', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600'];
};

export const bubbleChartColors = (isDark = false) => {
  return ['#44D2BE', '#7551E9', '#F6B31F', '#d45087', '#a05195', '#f95d6a', '#ff7c43'];
};

export const formatLeadsByMedium = (payload) => {
  if ((payload || {}).medium_aggregates) {
    const final = (payload.medium_aggregates || []).reduce((all, item) => {
      Object.entries(item.value || {}).forEach(([key, value]) => {
        if (all[key]) {
          let val = (all[key] += value);
          all[key] = val;
        } else {
          all[key] = value;
        }
      });
      return all;
    }, {});

    const final_arr = [];
    Object.entries(final).forEach(([key, value]) => {
      final_arr.push({ name: key === 'cpc' ? 'ads' : key, value });
    });
    payload.medium_aggregates = final_arr;
  }
  return payload;
};
